module.exports = "<app-header></app-header>\n<!--<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">-->\n      <ng-content></ng-content>\n    <!--</div>\n  </div>\n</div>-->\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/galeri-standard-template/galeri-standard-template.component.html
// module id = ../../../../../src/app/galeri-standard-template/galeri-standard-template.component.html
// module chunks = main